// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "app-main" + ".css?" + "b6c52b8f3ef3b0f27223" + "";
};